import { render } from "./BxsNumberField.vue?vue&type=template&id=2fe839d1&scoped=true"
import script from "./BxsNumberField.vue?vue&type=script&lang=js"
export * from "./BxsNumberField.vue?vue&type=script&lang=js"

import "./BxsNumberField.vue?vue&type=style&index=0&id=2fe839d1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fe839d1"]])

export default __exports__